import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-video',
  templateUrl: './error-video.component.html',
  styleUrls: ['./error-video.component.css']
})
export class ErrorVideoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
